import { render, staticRenderFns } from "./PerformanceWidgetListItem.vue?vue&type=template&id=4fd407c6"
import script from "./PerformanceWidgetListItem.vue?vue&type=script&lang=js"
export * from "./PerformanceWidgetListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports